(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cs-hockey-builder"] && !Shopify.designMode) return;
  try {
    (()=>{
"use strict";
const INK="#0b0a09";
const NAME_FONT="Saira Extra Condensed", NAME_W=700;
/* Number glyphs: Coastal Spirit's own outlined digits, in the original decal's number space
   (baseline 12941.548, cap height 435.413). No font needed. */
const GLYPHS={"3":{"d":"M18175.321,12540.509L18140.946,12506.135L18050.426,12506.135L18016.051,12540.509L18016.051,12630.446L18071.051,12630.446L18071.051,12563.426L18082.509,12551.968L18108.863,12551.968L18120.321,12563.426L18120.321,12684.883L18108.863,12692.342L18060.166,12692.342L18060.166,12748.466L18108.863,12748.466L18120.321,12755.925L18120.321,12884.257L18108.863,12895.715L18083.082,12895.715L18071.624,12884.257L18071.624,12810.437L18016.624,12810.437L18016.624,12907.174L18050.999,12941.548L18140.946,12941.548L18175.321,12907.174L18175.321,12755.352L18140.946,12720.404L18175.321,12686.029L18175.321,12540.509Z","x0":18016.051,"x1":18175.321},"4":{"d":"M18351.778,12773.112L18351.778,12506.135L18268.133,12506.135L18197.092,12770.247L18197.092,12820.091L18297.924,12820.091L18297.924,12941.548L18351.778,12941.548L18351.778,12820.091L18380.424,12820.091L18380.424,12773.112L18351.778,12773.112ZM18243.497,12773.112L18297.924,12561.134L18297.924,12773.112L18243.497,12773.112Z","x0":18197.092,"x1":18380.424},"2":{"d":"M17840.74,12941.548L17989.697,12941.548L17989.697,12894.569L17895.74,12894.569L17895.74,12760.508L17907.198,12749.05L17957.614,12749.05L17991.989,12714.675L17991.989,12540.509L17957.614,12506.135L17876.261,12506.135L17841.886,12540.509L17841.886,12617.28L17896.885,12617.28L17896.885,12564.572L17908.344,12553.113L17925.531,12553.113L17936.989,12564.572L17936.989,12689.467L17925.531,12700.925L17875.115,12700.925L17840.74,12735.3L17840.74,12941.548Z","x0":17840.74,"x1":17991.989},"9":{"d":"M19292.5,12540.509L19258.125,12506.135L19167.605,12506.135L19133.23,12540.509L19133.23,12724.414L19167.605,12758.789L19216.876,12758.789L19237.5,12738.164L19237.5,12883.111L19226.042,12894.569L19199.688,12894.569L19188.23,12883.111L19188.23,12821.237L19133.23,12821.237L19133.23,12907.174L19167.605,12941.548L19258.125,12941.548L19292.5,12907.174L19292.5,12540.509ZM19226.042,12553.113L19237.5,12564.572L19237.5,12700.352L19226.042,12711.81L19199.688,12711.81L19188.23,12700.352L19188.23,12564.572L19199.688,12553.113L19226.042,12553.113Z","x0":19133.23,"x1":19292.5},"8":{"d":"M19102.293,12540.509L19067.918,12506.135L18978.544,12506.135L18944.169,12540.509L18944.169,12685.456L18978.544,12719.831L18944.169,12754.206L18944.169,12907.174L18978.544,12941.548L19067.918,12941.548L19102.293,12907.174L19102.293,12754.206L19067.918,12719.831L19102.293,12685.456L19102.293,12540.509ZM19035.835,12553.113L19047.294,12564.572L19047.294,12684.883L19035.835,12696.342L19010.627,12696.342L18999.169,12684.883L18999.169,12564.572L19010.627,12553.113L19035.835,12553.113ZM19035.835,12743.32L19047.294,12754.779L19047.294,12883.111L19035.835,12894.569L19010.627,12894.569L18999.169,12883.111L18999.169,12754.779L19010.627,12743.32L19035.835,12743.32Z","x0":18944.169,"x1":19102.293},"6":{"d":"M18692.088,12564.572L18692.088,12626.446L18747.087,12626.446L18747.087,12540.509L18712.713,12506.135L18623.338,12506.135L18588.964,12540.509L18588.964,12907.174L18623.338,12941.548L18713.859,12941.548L18748.233,12907.174L18748.233,12723.269L18713.859,12688.894L18664.588,12688.894L18643.963,12709.519L18643.963,12564.572L18655.421,12553.113L18680.63,12553.113L18692.088,12564.572ZM18681.775,12735.873L18693.234,12747.331L18693.234,12883.111L18681.775,12894.569L18655.421,12894.569L18643.963,12883.111L18643.963,12747.331L18655.421,12735.873L18681.775,12735.873Z","x0":18588.964,"x1":18748.233},"7":{"d":"M18844.483,12941.548L18921.826,12538.218L18921.826,12506.135L18767.139,12506.135L18767.139,12553.113L18867.399,12553.113L18792.92,12941.548L18844.483,12941.548Z","x0":18767.139,"x1":18921.826},"5":{"d":"M18456.048,12553.113L18552.87,12553.113L18552.87,12506.135L18401.048,12506.135L18401.048,12707.227L18455.475,12724.414L18466.933,12712.956L18490.423,12712.956L18501.881,12724.414L18501.881,12883.111L18490.423,12894.569L18467.506,12894.569L18456.048,12883.111L18456.048,12821.237L18401.048,12821.237L18401.048,12907.174L18435.423,12941.548L18522.506,12941.548L18556.881,12907.174L18556.881,12700.352L18522.506,12665.977L18476.673,12665.977L18456.048,12686.602L18456.048,12553.113Z","x0":18401.048,"x1":18556.881},"1":{"d":"M17753.084,12941.548L17808.084,12941.548L17808.084,12506.135L17726.699,12506.135L17726.699,12553.113L17753.084,12553.113L17753.084,12941.548Z","x0":17726.699,"x1":17808.084},"0":{"d":"M17692.929,12540.509L17658.554,12506.135L17568.607,12506.135L17534.232,12540.509L17534.232,12907.174L17568.607,12941.548L17658.554,12941.548L17692.929,12907.174L17692.929,12540.509ZM17626.471,12553.113L17637.929,12564.572L17637.929,12883.111L17626.471,12894.569L17600.69,12894.569L17589.232,12883.111L17589.232,12564.572L17600.69,12553.113L17626.471,12553.113Z","x0":17534.232,"x1":17692.929}};
const G_BASE=12941.548, G_CAP=435.413, G_GAP=41*435.413/520; // same proportion as the helmet spacing
/* Pair kerning: pairs whose outlines wouldn't overlap solidly at standard spacing sit closer. */
const KERN={"41":26.3,"47":24.5,"74":9.7};
function layoutNum(num,gap){
  gap=gap==null?G_GAP:gap;
  let x=0, prev=null; const items=[];
  for(const ch of String(num||"00")){
    const g=GLYPHS[ch]; if(!g) continue;
    if(prev!==null) x+=(KERN[prev+ch]!=null?Math.min(gap,KERN[prev+ch]):gap);
    items.push({d:g.d,dx:x-g.x0}); x+=g.x1-g.x0; prev=ch;
  }
  return {items,width:Math.max(0,x)};
}
const DEFAULT_COLOURS="Gold|#ffc300\nVegas gold|#b9975b\nOrange|#f2711c\nRed|#d3202b\nMaroon|#7a1f30\nPink|#e9549a\nPurple|#6a35a8\nRoyal|#2357c8\nNavy|#1e3466\nSky|#29a8e0\nTeal|#00807f\nKelly green|#14924a\nForest|#1f5a3c\nSilver|#a7a9ac";
const esc=s=>String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
const fam=f=>`'${f}','Arial Narrow',Impact,sans-serif`;
const cleanName=(v,max)=>String(v||"").replace(/[^A-Za-zÀ-ÿ' .\-]/g,"").slice(0,max);
const cleanNum=v=>String(v||"").replace(/\D/g,"").slice(0,2);
const money=c=>{const d=c/100;return "$"+(Number.isInteger(d)?d:d.toFixed(2))};

/* Cap-height measurement so both faces sit at the sizes in the master art */
const mctx=document.createElement("canvas").getContext("2d");
const capCache={};
function capEm(f,w,ch){
  const k=f+w+ch; if(capCache[k]) return capCache[k];
  mctx.font=`${w} 200px ${fam(f)}`;
  const v=(mctx.measureText(ch).actualBoundingBoxAscent||140)/200;
  if(document.fonts&&document.fonts.check(`${w} 20px "${f}"`)) capCache[k]=v;
  return v;
}

/* ---- Stick decal: geometry from hockey_decal_test.svg. The frame grows with the name. ---- */
const NAME={x:1035,y:1762.867,size:50};
const GROW=11.458248/0.85352, FRAME_END=1861.146;
const NUM={cx:18412.8,y:12941.548,size:572.913,gold:24,ink:118};
const NUM_CAP=0.76, NAME_CAP=0.668;
function framePath(end){
  const a=end-124.597,b=end-55.83;
  return `M${a},195.027C${b},195.027 ${end},228.798 ${end},270.395L${end},544.881C${end},586.477 ${b},620.249 ${a},620.249L273.665,620.249C204.898,620.249 149.067,586.477 149.067,544.881L149.067,270.395C149.067,228.798 204.898,195.027 273.665,195.027L${a},195.027Z`;
}
function stickSVG(d){
  const name=(d.name||"").toUpperCase();
  const ns=NAME.size*NAME_CAP/capEm(NAME_FONT,NAME_W,"H");
  const L=layoutNum(d.num||"00"), ox=NUM.cx-L.width/2;
  const lay=attrs=>L.items.map(it=>`<path d="${it.d}" transform="translate(${(ox+it.dx).toFixed(3)},0)" ${attrs}/>`).join("");
  return `<svg viewBox="0 0 642 2209" role="img" aria-label="Stick decal: ${esc(d.num||"")} ${esc(name)}"><g class="decal"><g transform="matrix(1,0,0,1,-31382.590521,-11617.515271)">
    <g transform="matrix(0,0.85352,-1.411028,-0.289423,32277.055078,12313.780291)"><path class="frame" d="${framePath(FRAME_END)}" fill="${INK}"/></g>
    <g transform="matrix(0,11.458248,-11.458257,-2.349807,51709.614413,4909.475381)">
      <text class="name" x="${NAME.x}" y="${NAME.y}" font-size="${ns}" letter-spacing="1.4" style="font-family:${fam(NAME_FONT)};font-weight:${NAME_W}" fill="#fff">${esc(name)}</text></g>
    <g transform="matrix(1.667433,0.31005,0,1.667433,1001.01281,-14805.9663)">
      ${lay(`fill="none" stroke="${INK}" stroke-width="${NUM.ink}" stroke-linejoin="round"`)}
      ${lay(`fill="none" stroke="${d.acc}" stroke-width="${NUM.gold}" stroke-linejoin="miter" stroke-miterlimit="4"`)}
      ${lay(`fill="#fff"`)}</g>
  </g></g></svg>`;
}
const PAD=120;
function grow(svg){
  const g=svg&&svg.querySelector(".decal"); if(!g) return;
  const name=g.querySelector(".name"), frame=g.querySelector(".frame");
  let w=0;try{w=name.getComputedTextLength()}catch(e){}
  frame.setAttribute("d",framePath(FRAME_END+(NAME.x+Math.max(w,38)-1118.1)*GROW));
  let bb;try{bb=g.getBBox()}catch(e){return}
  if(!bb||!bb.height) return;
  const h=Math.max(bb.height+2*PAD,2209+2*PAD), wd=Math.max(bb.width+2*PAD,642+2*PAD);
  svg.setAttribute("viewBox",`${bb.x+bb.width/2-wd/2} ${bb.y-PAD} ${wd} ${h}`);
}

/* ---- Helmet number: custom digits, upright. Measured from the master (cap 520): black keyline 14 out,
   team colour 46 out, 41 between digit faces. The thick outer stroke fuses the digits into one solid
   piece, so it peels off the sheet in one go. ---- */
const HEL={cap:520,key:14,out:39.6,gap:41}; // colour band 25.6 past the keyline (was 32)
function helmetSVG(num,acc){
  const k=HEL.cap/G_CAP, L=layoutNum(num||"00",HEL.gap/k), w=L.width*k, pad=HEL.out+12;
  const lay=attrs=>L.items.map(it=>`<path d="${it.d}" transform="translate(${it.dx.toFixed(3)},0)" ${attrs}/>`).join("");
  return `<svg viewBox="${-pad} ${-HEL.cap-pad} ${w+2*pad} ${HEL.cap+2*pad}" role="img" aria-label="Helmet number ${esc(num||"00")}">
    <g transform="scale(${k}) translate(0,${-G_BASE})">
    ${lay(`fill="${acc}" stroke="${acc}" stroke-width="${(2*HEL.out/k).toFixed(3)}" stroke-linejoin="miter" stroke-miterlimit="2"`)}
    ${lay(`fill="${INK}" stroke="${INK}" stroke-width="${(2*HEL.key/k).toFixed(3)}" stroke-linejoin="miter" stroke-miterlimit="4"`)}
    ${lay(`fill="#fff"`)}</g></svg>`;
}

function parseRoster(text,max){
  const out=[];
  String(text||"").split(/\r?\n/).forEach(line=>{
    const l=line.trim(); if(!l) return;
    const m=l.match(/(^|[^\d])(\d{1,2})(?!\d)/);
    const num=m?m[2]:"";
    const name=cleanName(l.replace(/\d+/g," ").replace(/[,\t#;|]+/g," ").replace(/\s+/g," ").replace(/^[^A-Za-zÀ-ÿ']+|[^A-Za-zÀ-ÿ.']+$/g,"").trim(),max).toUpperCase();
    if(num||name) out.push({num,name});
  });
  return out;
}
const X_ICON=`<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>`;

class CsHockeyBuilder extends HTMLElement{
  connectedCallback(){
    if(this._init) return; this._init=true;
    const d=this.dataset, q=s=>this.querySelector(s);
    this.formId=d.formId;
    this.max=+d.max||14;
    this.price=+d.price||3000;
    this.teamPrice=Math.round((+d.teamPrice||20)*100);
    this.teamMin=+d.teamMin||10;
    this.colours=(d.colours||DEFAULT_COLOURS).split(/\r?\n/).map(l=>l.split("|").map(s=>s.trim())).filter(c=>c[0]&&/^#[0-9a-f]{3,8}$/i.test(c[1]||""));
    if(!this.colours.length) this.colours=DEFAULT_COLOURS.split("\n").map(l=>l.split("|"));
    this.state={mode:"solo",accent:0,sel:0,roster:[{num:"",name:""}]};

    this.nameInput=q("[data-name]"); this.numInput=q("[data-num]");
    this.count=q("[data-count]"); this.hint=q("[data-hint]");
    this.hintDefault=this.hint?this.hint.textContent:"";
    this.colourInput=q("[data-colour-input]"); this.hexInput=q("[data-hex-input]");

    /* Swatches */
    const sw=q("[data-swatches]");
    this.colours.forEach(([n,hex],i)=>{
      const b=document.createElement("button");
      b.type="button"; b.className="cs-hk__sw"; b.style.background=hex;
      b.setAttribute("role","radio"); b.setAttribute("aria-label",n); b.title=n;
      b.addEventListener("click",()=>{this.state.accent=i;this.update()});
      sw.appendChild(b);
    });
    sw.addEventListener("keydown",e=>{
      const k={ArrowRight:1,ArrowDown:1,ArrowLeft:-1,ArrowUp:-1}[e.key]; if(!k) return;
      e.preventDefault(); const n=this.colours.length;
      this.state.accent=(this.state.accent+k+n)%n; this.update(); sw.children[this.state.accent].focus();
    });

    /* Name + number (Just me): capitals in the field itself, so the cart matches the decal */
    const caps=()=>{
      const el=this.nameInput, raw=el.value, clean=cleanName(raw,this.max).toUpperCase();
      if(raw===clean) return false;
      const end=el.selectionEnd, shift=clean.length-raw.length;
      el.value=clean; try{if(end!=null) el.setSelectionRange(end+shift,end+shift)}catch(e){}
      return cleanName(raw,this.max).length!==raw.slice(0,this.max).length;
    };
    this.nameInput.addEventListener("input",e=>{
      if(e.isComposing) return;
      if(caps()) this.flash("Letters, spaces, apostrophes, hyphens and periods only.");
      this.update();
    });
    this.nameInput.addEventListener("compositionend",()=>{caps();this.update()});
    this.numInput.addEventListener("input",()=>{const c=cleanNum(this.numInput.value);if(c!==this.numInput.value)this.numInput.value=c;this.update()});

    /* Team mode */
    this.teamOn=d.team==="true"&&!!q("[data-team-panel]");
    if(this.teamOn){
      this.querySelectorAll("[data-mode]").forEach(b=>b.addEventListener("click",()=>this.setMode(b.dataset.mode)));
      const to=q("[data-to-team]"); if(to) to.addEventListener("click",()=>this.setMode("team"));
      this.rows=q("[data-rows]");
      this.rows.addEventListener("input",e=>this.onRowInput(e));
      this.rows.addEventListener("focusin",e=>{const r=e.target.closest("[data-i]");if(r&&+r.dataset.i!==this.state.sel){this.state.sel=+r.dataset.i;this.markRows();this.renderPreview()}});
      this.rows.addEventListener("keydown",e=>{
        if(e.key!=="Enter") return; const r=e.target.closest("[data-i]"); if(!r) return;
        e.preventDefault(); const i=+r.dataset.i;
        if(e.target.dataset.f==="num") r.querySelector('[data-f="name"]').focus(); else this.addRowAfter(i);
      });
      this.rows.addEventListener("click",e=>{
        const b=e.target.closest("[data-rm]"); if(!b) return;
        const i=+b.dataset.rm; this.state.roster.splice(i,1);
        if(!this.state.roster.length) this.state.roster.push({num:"",name:""});
        this.state.sel=Math.min(this.state.sel,this.state.roster.length-1);
        this.renderRows(); this.update();
      });
      q("[data-add-row]").addEventListener("click",()=>this.addRowAfter(this.state.roster.length-1));
      const paste=q("[data-paste]"), box=q("[data-pastebox]"), found=q("[data-paste-found]"), tog=q("[data-paste-toggle]");
      const show=on=>{paste.hidden=!on;tog.setAttribute("aria-expanded",on);if(on)box.focus();else{box.value="";found.textContent="Number and name, any order"}};
      tog.addEventListener("click",()=>show(paste.hidden));
      q("[data-paste-cancel]").addEventListener("click",()=>show(false));
      box.addEventListener("input",()=>{const n=parseRoster(box.value,this.max).length;found.textContent=n?`${n} player${n===1?"":"s"} found`:"Number and name, any order"});
      q("[data-paste-add]").addEventListener("click",()=>{
        const p=parseRoster(box.value,this.max); if(!p.length) return;
        this.state.roster=this.state.roster.filter(r=>r.num||r.name).concat(p,[{num:"",name:""}]);
        this.state.sel=0; show(false); this.renderRows(); this.update();
      });
      /* Whole team: capture the theme's add-to-cart before Horizon handles it, and add one line per player */
      this._onSubmit=e=>{
        /* getAttribute, not .id: the product form has an input named "id", which shadows form.id */
        if(this.state.mode!=="team"||!e.target||!e.target.getAttribute||e.target.getAttribute("id")!==this.formId) return;
        e.preventDefault(); e.stopImmediatePropagation(); this.addTeam(e.target);
      };
      /* Window capture runs before Horizon's own document-level submit handler, so only the team add happens */
      window.addEventListener("submit",this._onSubmit,true);
      const sp=q("[data-solo-price]"), tp=q("[data-team-price]"), tl=q("[data-to-team]");
      if(sp) sp.textContent=`${money(this.price)} per pack`;
      if(tp) tp.textContent=`${money(this.teamPrice)} per player at ${this.teamMin}+`;
      if(tl) tl.textContent=`Ordering for the team? ${money(this.teamPrice)} per player at ${this.teamMin}+`;
    }

    this.setupStage();
    this.update();
    if(document.fonts&&document.fonts.load){
      Promise.all([document.fonts.load(`${NAME_W} 40px "${NAME_FONT}"`,"ABCDEFGHIJKLMNOPQRSTUVWXYZ'")].map(p=>p.catch(()=>{})))
        .then(()=>{for(const k in capCache)delete capCache[k];this.renderPreview()});
    }
  }
  disconnectedCallback(){ if(this._onSubmit) window.removeEventListener("submit",this._onSubmit,true); }

  flash(msg){
    if(!this.hint) return;
    this.hint.textContent=msg; this.hint.classList.add("is-note");
    clearTimeout(this._ht); this._ht=setTimeout(()=>{this.hint.textContent=this.hintDefault;this.hint.classList.remove("is-note")},2200);
  }

  /* ---- Preview: on the first gallery image if set, otherwise inside the block ---- */
  sceneHTML(){
    return `<div class="cs-hk-scene" role="img" aria-label="Live preview of your decals">
      <div class="cs-hk-scene__grid">
        <div class="cs-hk-scene__cell"><div class="cs-hk-scene__art" data-art="stick"></div><div class="cs-hk-scene__tag">Stick ×4</div></div>
        <div class="cs-hk-scene__cell cs-hk-scene__cell--helmet"><div class="cs-hk-scene__art" data-art="helmet"></div><div class="cs-hk-scene__tag">Helmet ×2</div></div>
      </div>
    </div>`;
  }
  setupStage(){
    const wrap=this.querySelector("[data-stagewrap]");
    wrap.innerHTML=this.sceneHTML();
    this.hosts=[wrap];
    if(this.dataset.gallery!=="true") return;
    if(!this.placeInGallery()) return;
    /* If the theme ever re-renders the gallery (e.g. a variant change), put the preview back */
    const root=this.closest(".shopify-section")||document.body;
    new MutationObserver(()=>{
      if(this.hosts.every(h=>h.isConnected)) return;
      this.hosts.forEach(h=>h.remove());
      if(this.placeInGallery()){this.observeHosts();this.renderPreview()}
    }).observe(root,{childList:true,subtree:true});
    /* Mobile: a slim preview strip while typing, once the gallery has scrolled away */
    this.mini=this.querySelector("[data-mini]");
    this.observeHosts();
    this.addEventListener("focusin",()=>{this.typing=true;this.toggleMini()});
    this.addEventListener("focusout",()=>setTimeout(()=>{this.typing=this.contains(document.activeElement);this.toggleMini()},50));
  }
  /* The preview becomes the whole media column; the theme's photo grid, slideshow and zoom are hidden. */
  placeInGallery(){
    const root=this.closest(".shopify-section")||document;
    const gallery=root.querySelector("media-gallery"); if(!gallery) return false;
    const host=document.createElement("div");
    host.className="cs-hk-gallery-preview";
    host.style.setProperty("--hk-scene",getComputedStyle(this).getPropertyValue("--hk-scene"));
    host.innerHTML=this.sceneHTML();
    gallery.prepend(host);
    gallery.classList.add("cs-hk-takeover");
    this.hosts=[host];
    this.classList.add("is-in-gallery");
    return true;
  }
  observeHosts(){
    if(this._io) this._io.disconnect();
    this.sceneSeen=true;
    if(!("IntersectionObserver" in window)) return;
    const vis=new Map();
    this._io=new IntersectionObserver(es=>{es.forEach(e=>vis.set(e.target,e.intersectionRatio>=.35&&e.target.offsetParent!==null));this.sceneSeen=[...vis.values()].some(Boolean);this.toggleMini()},{threshold:[0,.35,.6]});
    this.hosts.forEach(h=>this._io.observe(h));
  }
  toggleMini(){
    if(!this.mini) return;
    this.mini.hidden=!(window.matchMedia("(max-width: 749px)").matches&&this.typing&&!this.sceneSeen);
  }
  current(){
    const acc=this.colours[this.state.accent][1], d=this.dataset;
    let num,name;
    if(this.state.mode==="team"){const r=this.state.roster[this.state.sel]||{};num=r.num;name=r.name}
    else{num=this.numInput.value;name=this.nameInput.value}
    return {num:num||d.demoNum||"17",name:name||d.demoName||"YOUR NAME",acc,real:!!(num||name)};
  }
  renderPreview(){
    const c=this.current();
    this.hosts.forEach(h=>{
      const st=h.querySelector('[data-art="stick"]'), he=h.querySelector('[data-art="helmet"]');
      if(!st) return;
      st.innerHTML=stickSVG(c); grow(st.querySelector("svg"));
      he.innerHTML=helmetSVG(c.num,c.acc);
    });
    if(this.mini) this.mini.innerHTML=`${helmetSVG(c.num,c.acc)}<b>${esc(c.name)}</b>`;
  }

  /* ---- Team roster ---- */
  setMode(m){
    this.state.mode=m;
    this.querySelectorAll("[data-mode]").forEach(b=>b.setAttribute("aria-pressed",b.dataset.mode===m));
    this.querySelector("[data-solo]").hidden=m!=="solo";
    this.querySelector("[data-team-panel]").hidden=m!=="team";
    /* Disabled fields are skipped by the form, so Just me's required fields don't block a team order */
    this.querySelectorAll("[data-solo-field]").forEach(el=>el.disabled=m==="team");
    const sec=this.closest(".shopify-section")||document.body;
    sec.classList.toggle("cs-hk-team-on",m==="team");
    if(m==="team") this.renderRows();
    this.update();
  }
  filled(){return this.state.roster.filter(r=>r.num&&r.name.trim())}
  /* Duplicates are allowed (extra copies of a player are fine). Only a shared number with different names gets a quiet note, since that's usually a typo. */
  clashes(){const m={};this.filled().forEach(r=>{(m[r.num]=m[r.num]||new Set()).add(r.name.trim())});return Object.keys(m).filter(k=>m[k].size>1).map(k=>({num:k,names:[...m[k]]}))}
  renderRows(focus){
    this.rows.innerHTML=this.state.roster.map((r,i)=>`<div class="cs-hk__rrow" data-i="${i}">
      <input type="text" class="field__input cs-hk__input cs-hk__input--num" data-f="num" inputmode="numeric" maxlength="2" autocomplete="off" placeholder="00" value="${esc(r.num)}" aria-label="Player ${i+1} number">
      <input type="text" class="field__input cs-hk__input cs-hk__input--name" data-f="name" maxlength="${this.max}" autocomplete="off" autocapitalize="characters" placeholder="Name" value="${esc(r.name)}" aria-label="Player ${i+1} name">
      <button type="button" class="cs-hk__x" data-rm="${i}" aria-label="Remove player ${i+1}">${X_ICON}</button></div>`).join("");
    if(focus){const el=this.rows.querySelector(`[data-i="${focus[0]}"] [data-f="${focus[1]}"]`);if(el)el.focus()}
    this.markRows();
  }
  markRows(){
    this.rows.querySelectorAll("[data-i]").forEach((row,i)=>row.classList.toggle("is-sel",i===this.state.sel));
    const note=this.querySelector("[data-team-note]"), c=this.clashes()[0];
    if(note) note.textContent=c?`Heads up: #${c.num} is on ${c.names.join(" and ")}. Just checking that's intended.`:"";
    const err=this.querySelector("[data-team-err]");
    if(err&&!this._submitErr) err.textContent="";
  }
  onRowInput(e){
    const row=e.target.closest("[data-i]"); if(!row) return;
    const i=+row.dataset.i, f=e.target.dataset.f;
    const v=f==="num"?cleanNum(e.target.value):cleanName(e.target.value,this.max).toUpperCase();
    if(e.target.value!==v){const end=e.target.selectionEnd,s=v.length-e.target.value.length;e.target.value=v;try{e.target.setSelectionRange(end+s,end+s)}catch(_){}}
    this.state.roster[i][f]=v; this.state.sel=i; this._submitErr=false; this.markRows(); this.update();
  }
  addRowAfter(i){this.state.roster.splice(i+1,0,{num:"",name:""});this.state.sel=i+1;this.renderRows([i+1,"num"]);this.update()}

  update(){
    const [cname,hex]=this.colours[this.state.accent];
    this.querySelectorAll(".cs-hk__sw").forEach((b,i)=>{b.setAttribute("aria-checked",i===this.state.accent);b.tabIndex=i===this.state.accent?0:-1});
    this.querySelector("[data-colour-name]").textContent=`· ${cname}`;
    this.colourInput.value=cname; this.hexInput.value=hex;
    if(this.count) this.count.textContent=`${this.nameInput.value.length}/${this.max}`;
    if(this.teamOn&&this.state.mode==="team"){
      const n=this.filled().length, hit=n>=this.teamMin, unit=hit?this.teamPrice:this.price, left=Math.max(0,this.teamMin-n);
      const q=s=>this.querySelector(s);
      q("[data-count-players]").textContent=`· ${n} player${n===1?"":"s"}`;
      q("[data-tier-msg]").textContent=left?`Add ${left} more to unlock ${money(this.teamPrice)} per player`:`Team pricing unlocked: ${money(this.teamPrice)} per player`;
      q("[data-tier-count]").textContent=`${Math.min(n,this.teamMin)} / ${this.teamMin}`;
      const m=q("[data-meter]"); m.style.width=Math.min(100,n/this.teamMin*100)+"%"; m.classList.toggle("is-done",!left);
      q("[data-total]").textContent=`${money(n*unit)} CAD`;
      q("[data-unit]").textContent=hit?`${n} × ${money(this.teamPrice)} · you save ${money(n*(this.price-this.teamPrice))}`:`${n} × ${money(this.price)}`;
    }
    this.renderPreview();
  }

  async addTeam(form){
    const err=this.querySelector("[data-team-err]");
    const fail=msg=>{this._submitErr=true;err.textContent=msg;err.scrollIntoView({block:"nearest",behavior:"smooth"})};
    const half=this.state.roster.findIndex(r=>!!r.num!==!!r.name.trim());
    if(half>-1) return fail(`Player ${half+1} needs both a number and a name.`);
    const players=this.filled();
    if(!players.length) return fail("Add at least one player to the roster.");
    this._submitErr=false; err.textContent="";
    const idEl=form.querySelector('[name="id"]'); const id=idEl&&+idEl.value;
    if(!id) return fail("This product isn't available right now.");
    const [cname,hex]=this.colours[this.state.accent];
    const team=`${cname} · ${players.length} players · ${Date.now().toString(36).slice(-5).toUpperCase()}`;
    const items=players.map(p=>({id,quantity:1,properties:{"Number":p.num,"Name Bar Text":p.name.trim().toUpperCase(),"Team Colour":cname,"_hex":hex,"_team":team}}));
    const sections=[...document.querySelectorAll("cart-items-component")].map(el=>el.dataset.sectionId).filter(Boolean);
    const btns=form.querySelectorAll('[type="submit"]'); btns.forEach(b=>b.disabled=true);
    const routes=(window.Theme&&Theme.routes)||{};
    try{
      const res=await fetch(`${routes.cart_add_url||"/cart/add"}.js`,{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items,sections:sections.join(",")})});
      const json=await res.json();
      if(!res.ok||json.status) return fail(json.description||json.message||"Couldn't add the team to your cart. Try again.");
      try{
        const ev=await import("@theme/events");
        const pf=form.closest("product-form-component");
        document.dispatchEvent(new ev.CartAddEvent({},String(id),{source:"cs-hockey-builder",itemCount:items.length,productId:pf&&pf.dataset.productId,sections:json.sections}));
      }catch(e){ window.location.href=routes.cart_url||"/cart"; }
    }catch(e){ fail("Couldn't reach the cart. Check your connection and try again."); }
    finally{ btns.forEach(b=>b.disabled=false); }
  }
}
if(!customElements.get("cs-hockey-builder")) customElements.define("cs-hockey-builder",CsHockeyBuilder);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cs-namebar-builder"] && !Shopify.designMode) return;
  try {
    (()=>{
"use strict";
const SHEAR=-0.212551, H=600;
const FRAME={left:107.32, r:106.3};
const WIN={left:222.42, top:102.63, bot:497.37, r:70};
const SINGLE_RIGHT=969.01;                     // one-flag window right edge
const SPLIT={right:1034.19, aTop:679.39, aBot:545.12, bTop:711.68, bBot:577.41}; // diagonal cut, 32.3 gap
const TEXT={gap:113.7, base:491.65, cap:382.71, tail:148.4};  // name starts 113.7 after the window; frame ends 148.4 after the name
const BARS={light:{frame:"#f9f7f6",ink:"#0b0a09"},dark:{frame:"#0b0a0a",ink:"#ffffff"}};
const CODES="AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BM BN BO BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET EU FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HN HR HT HU IC ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UN US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW".split(" ");
const US={AL:"Alabama",AK:"Alaska",AZ:"Arizona",AR:"Arkansas",CA:"California",CO:"Colorado",CT:"Connecticut",DE:"Delaware",DC:"Washington, D.C.",FL:"Florida",GA:"Georgia",HI:"Hawaii",ID:"Idaho",IL:"Illinois",IN:"Indiana",IA:"Iowa",KS:"Kansas",KY:"Kentucky",LA:"Louisiana",ME:"Maine",MD:"Maryland",MA:"Massachusetts",MI:"Michigan",MN:"Minnesota",MS:"Mississippi",MO:"Missouri",MT:"Montana",NE:"Nebraska",NV:"Nevada",NH:"New Hampshire",NJ:"New Jersey",NM:"New Mexico",NY:"New York",NC:"North Carolina",ND:"North Dakota",OH:"Ohio",OK:"Oklahoma",OR:"Oregon",PA:"Pennsylvania",RI:"Rhode Island",SC:"South Carolina",SD:"South Dakota",TN:"Tennessee",TX:"Texas",UT:"Utah",VT:"Vermont",VA:"Virginia",WA:"Washington",WV:"West Virginia",WI:"Wisconsin",WY:"Wyoming"};
const CAP={AB:"Alberta",BC:"British Columbia",MB:"Manitoba",NB:"New Brunswick",NL:"Newfoundland and Labrador",NS:"Nova Scotia",NT:"Northwest Territories",NU:"Nunavut",ON:"Ontario",PE:"Prince Edward Island",QC:"Quebec",SK:"Saskatchewan",YT:"Yukon"};
const GBN={ENG:"England",SCT:"Scotland",WLS:"Wales",NIR:"Northern Ireland"};
let dn=null; try{dn=new Intl.DisplayNames(["en"],{type:"region"})}catch(e){}
const NAME_FIX={CD:"DR Congo",CG:"Republic of the Congo",MM:"Myanmar",CI:"Ivory Coast",PS:"Palestine",HK:"Hong Kong",MO:"Macau",EU:"European Union",UN:"United Nations",IC:"Canary Islands",XK:"Kosovo",US:"United States",GB:"United Kingdom",TR:"Türkiye",CZ:"Czechia",KR:"South Korea",KP:"North Korea",VA:"Vatican City",FM:"Micronesia",ST:"São Tomé and Príncipe",SZ:"Eswatini"};
const LIB=[]; const BY={};
function add(code,name,group,aliases){const o={code,name,group,aliases:aliases||[]};LIB.push(o);BY[code]=o}
CODES.forEach(c=>{let n=NAME_FIX[c]||(dn?dn.of(c):c)||c;n=n.replace(/\s*\(.*\)$/,"");add(c,n,"Countries")});
Object.entries(US).forEach(([k,v])=>add("US-"+k,v,"US states",[k]));
Object.entries(CAP).forEach(([k,v])=>add("CA-"+k,v,"Canadian provinces",[k]));
Object.entries(GBN).forEach(([k,v])=>add("GB-"+k,v,"UK nations"));
add("IT-25","Lombardy","Regions",["Lombardia"]);
const ALIAS={"lombardia":"IT-25","usa":"US","us":"US","u s":"US","u s a":"US","united states of america":"US","america":"US","the united states":"US","uk":"GB","great britain":"GB","britain":"GB","united kingdom":"GB","holland":"NL","the netherlands":"NL","korea":"KR","south korea":"KR","republic of korea":"KR","north korea":"KP","russia":"RU","czech republic":"CZ","ivory coast":"CI","cote divoire":"CI","turkey":"TR","turkiye":"TR","vietnam":"VN","viet nam":"VN","burma":"MM","east timor":"TL","cape verde":"CV","swaziland":"SZ","vatican":"VA","dr congo":"CD","drc":"CD","congo":"CG","uae":"AE","emirates":"AE","washington dc":"US-DC","dc":"US-DC","washington d c":"US-DC","district of columbia":"US-DC","newfoundland":"CA-NL","pei":"CA-PE","quebec":"CA-QC","quebec province":"CA-QC","bc":"CA-BC","nwt":"CA-NT","yukon territory":"CA-YT","persia":"IR","macedonia":"MK","north macedonia":"MK","bosnia":"BA","trinidad":"TT","puerto rico":"PR","the bahamas":"BS","bahamas":"BS","the gambia":"GM","gambia":"GM","palestine":"PS","hong kong":"HK","taiwan":"TW","new york state":"US-NY","cali":"US-CA","mexico":"MX","mx":"MX","ca":"CA"};
const AMBIG={"georgia":["GE","US-GA"],"washington":["US-WA","US-DC"],"punjab":[],"ca":["CA","US-CA"]};
const HOIST=new Set("US AU NZ FJ TV MY LR TW GR CL TG UY CK NU CU CZ PH BS JO SD PS KW TL ER MZ PR AE ZW SS US-HI US-TX US-NC US-MS".split(" "));
const norm=s=>String(s||"").normalize("NFD").replace(/[̀-ͯ]/g,"").toLowerCase().replace(/[’'`]/g,"").replace(/[^a-z0-9]+/g," ").trim();
const INDEX=new Map();
LIB.forEach(o=>{INDEX.set(norm(o.name),o.code)});
Object.entries(ALIAS).forEach(([k,v])=>{if(!INDEX.has(k))INDEX.set(k,v)});
function formatName(raw){
  const s=String(raw||"").trim().toUpperCase().replace(/\s+/g," ");
  let m=s.match(/^([A-Z])\.\s*([A-Z])(?:\.\s*|\s+)([A-Z][A-Z'’-]+(?:\s.*)?)$/);
  if(m) {const t=`${m[1]}.${m[2]}. ${m[3]}`;return {text:t,changed:t!==s}}
  m=s.match(/^([A-Z])(?:\.\s*|\s+)([A-Z][A-Z'’-]+(?:\s.*)?)$/);
  if(m) {const t=`${m[1]}. ${m[2]}`;return {text:t,changed:t!==s}}
  return {text:s,changed:false};
}
const ASPECT={"IT-25":1.5,"AC":2.0,"AD":1.4286,"AE":2.0,"AF":1.5,"AG":1.5,"AI":2.0,"AL":1.4,"AM":2.0,"AO":1.5,"AQ":1.5,"AR":1.6,"AS":2.0,"AT":1.5,"AU":2.0,"AW":1.5,"AX":1.5294,"AZ":2.0,"BA":2.0,"BB":1.5,"BD":1.6667,"BE":1.1538,"BF":1.5,"BG":1.6667,"BH":1.6667,"BI":1.6667,"BJ":1.5,"BL":1.5,"BM":2.0,"BN":2.0,"BO":1.4667,"BQ":1.5,"BR":1.4286,"BS":2.0,"BT":1.5,"BV":1.375,"BW":1.5,"BY":2.0,"BZ":1.5,"CA-AB":2.0,"CA-BC":1.6667,"CA-MB":2.0,"CA-NB":1.6,"CA-NL":2.0,"CA-NS":2.0,"CA-NT":2.0,"CA-NU":1.7766,"CA-ON":2.0,"CA-PE":1.5,"CA-QC":1.5,"CA-SK":2.0,"CA-YT":2.0,"CA":2.0,"CC":2.0,"CD":1.3333,"CF":1.5,"CG":1.5,"CH":1.0,"CI":1.5,"CK":2.0,"CL":1.5,"CM":1.5,"CN":1.5,"CO":1.5,"CP":1.5,"CR":1.6667,"CU":2.0,"CV":1.7,"CW":1.5,"CX":2.0,"CY":1.5278,"CZ":1.5,"DE":1.6667,"DG":2.0,"DJ":1.5,"DK":1.3214,"DM":2.0,"DO":1.6,"DZ":1.5,"EA":1.5,"EC":1.5,"EE":1.5714,"EG":1.5,"EH":2.0,"ER":2.0,"ES":1.5,"ET":2.0,"EU":1.5,"FI":1.6364,"FJ":2.0,"FK":2.0,"FM":1.9,"FO":1.375,"FR":1.5,"GA":1.3333,"GB-ENG":1.6667,"GB-NIR":2.0,"GB-SCT":1.6667,"GB-WLS":1.5,"GB":2.0,"GD":1.6667,"GE":1.5,"GF":1.5,"GG":1.5,"GH":1.5,"GI":2.0,"GL":1.5,"GM":1.5,"GN":1.5,"GP":1.5,"GQ":1.5,"GR":1.5,"GS":2.0,"GT":1.6,"GU":1.8636,"GW":2.0,"GY":1.6667,"HK":1.5,"HM":2.0,"HN":2.0,"HR":2.0,"HT":1.6667,"HU":2.0,"IC":1.5,"ID":1.5,"IE":2.0,"IL":1.375,"IM":2.0,"IN":1.5,"IO":2.0,"IQ":1.5,"IR":1.75,"IS":1.3889,"IT":1.5,"JE":1.6667,"JM":2.0,"JO":2.0,"JP":1.5,"KE":1.5,"KG":1.6667,"KH":1.5625,"KI":2.0,"KM":1.6667,"KN":1.5,"KP":2.0,"KR":1.5,"KW":2.0,"KY":2.0,"KZ":2.0,"LA":1.5,"LB":1.5,"LC":2.0,"LI":1.6667,"LK":2.0,"LR":1.9,"LS":1.5,"LT":1.6667,"LU":1.6667,"LV":2.0,"LY":2.0,"MA":1.5,"MC":1.25,"MD":2.0,"ME":2.0,"MF":1.5,"MG":1.5,"MH":1.9,"MK":2.0,"ML":1.5,"MM":1.5,"MN":2.0,"MO":1.5,"MP":2.0,"MQ":1.5,"MR":1.5,"MS":2.0,"MT":1.5,"MU":1.5,"MV":1.5,"MW":1.5,"MX":1.75,"MY":2.0,"MZ":1.5,"NA":1.5,"NC":2.0,"NE":1.1667,"NF":2.0,"NG":2.0,"NI":1.6667,"NL":1.5,"NO":1.375,"NP":0.8203,"NR":2.0,"NU":2.0,"NZ":2.0,"OM":2.0,"PA":1.5,"PE":1.5,"PF":1.5,"PG":1.3333,"PH":2.0,"PK":1.5,"PL":1.6,"PM":1.5,"PN":2.0,"PR":1.5,"PS":2.0,"PT":1.5,"PW":1.6,"PY":1.8182,"QA":4.1667,"RE":1.5,"RO":1.5,"RS":1.5,"RU":1.5,"RW":1.5,"SA":1.5,"SB":2.0,"SC":2.0,"SD":2.0,"SE":1.6,"SG":1.5,"SH":2.0,"SI":2.0,"SJ":1.375,"SK":1.5,"SL":1.5,"SM":1.3333,"SN":1.5,"SO":1.5,"SR":1.5,"SS":2.0,"ST":2.0,"SV":1.7733,"SX":1.5,"SY":1.5,"SZ":1.5,"TA":2.0,"TC":2.0,"TD":1.5,"TF":1.5,"TG":1.618,"TH":1.5,"TJ":2.0,"TK":2.0,"TL":2.0,"TM":1.5,"TN":1.5,"TO":2.0,"TR":1.5,"TT":1.6667,"TV":2.0,"TW":1.5,"TZ":1.5,"UA":1.5,"UG":1.5,"UM":1.9,"UN":1.5,"US-AK":1.416,"US-AL":1.5,"US-AR":1.5,"US-AZ":1.5,"US-CA":1.5,"US-CO":1.5,"US-CT":1.2941,"US-DC":2.0,"US-DE":1.5,"US-FL":1.5,"US-GA":1.6,"US-HI":2.0,"US-IA":1.4597,"US-ID":1.2692,"US-IL":1.6917,"US-IN":1.5,"US-KS":1.6667,"US-KY":1.9,"US-LA":1.5714,"US-MA":1.6667,"US-MD":1.5,"US-ME":1.5,"US-MI":1.4989,"US-MN":1.5714,"US-MO":1.7143,"US-MS":1.5,"US-MT":1.5,"US-NC":1.5,"US-ND":1.2778,"US-NE":1.6667,"US-NH":1.5,"US-NJ":1.5,"US-NM":1.5,"US-NV":1.5,"US-NY":2.0,"US-OH":1.625,"US-OK":1.5,"US-OR":1.6667,"US-PA":1.5,"US-RI":1.0714,"US-SC":1.5,"US-SD":1.6,"US-TN":1.6667,"US-TX":1.5,"US-UT":1.6622,"US-VA":1.4589,"US-VT":1.6667,"US-WA":1.6809,"US-WI":1.5,"US-WV":1.9,"US-WY":1.4286,"US":1.9,"UY":1.5,"UZ":2.0,"VA":1.0,"VC":1.5,"VE":1.5,"VG":2.0,"VI":1.5,"VN":1.5,"VU":1.6667,"WF":1.5,"WS":2.0,"XK":1.4,"YE":1.5,"YT":1.5,"ZA":1.5,"ZM":1.5,"ZW":2.0};
function cover(code,x,y,w,h){
  const a=ASPECT[code]||1.5;
  let iw,ih; if(a>w/h){ih=h;iw=h*a}else{iw=w;ih=w/a}
  const ix=HOIST.has(code)?x:x+(w-iw)/2, iy=y+(h-ih)/2;
  return {x:ix,y:iy,w:iw,h:ih};
}

/* ---------- Coastal Spirit name bar builder (theme block) ---------- */
const FONT_FAMILY="Saira Extra Condensed", FONT_WEIGHT=700, FONT_CSS="'Saira Extra Condensed','Arial Narrow',sans-serif";
const esc=s=>String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
const mctx=document.createElement("canvas").getContext("2d");
let capRatio=null;
function fontSize(){
  if(!capRatio){
    mctx.font=`${FONT_WEIGHT} 200px ${FONT_CSS}`;
    const v=(mctx.measureText("H").actualBoundingBoxAscent||140)/200;
    if(document.fonts&&document.fonts.check(`${FONT_WEIGHT} 20px "${FONT_FAMILY}"`)) capRatio=v; else return TEXT.cap/v;
  }
  return TEXT.cap/capRatio;
}
function advance(text){const fs=fontSize();mctx.font=`${FONT_WEIGHT} ${fs}px ${FONT_CSS}`;return mctx.measureText(text).width}
let UID=0;
function decalSVG(o,flagHref){
  const id="csnb"+(++UID), c=BARS[o.bar];
  const name=formatName(o.name).text||"YOUR NAME";
  const flagRight=o.mode==="split"?SPLIT.right:SINGLE_RIGHT;
  const tx=flagRight+TEXT.gap;
  const right=Math.max(tx+advance(name)+TEXT.tail, tx+700);
  const T=WIN.top,B=WIN.bot,L=WIN.left,r=WIN.r,h=B-T;
  let slots;
  if(o.mode==="split"){
    const R=SPLIT.right;
    slots=[
      {code:o.flags[0],x:L,w:SPLIT.aTop-L,d:`M${SPLIT.aTop},${T}H${L+r}A${r},${r} 0 0 0 ${L},${T+r}V${B-r}A${r},${r} 0 0 0 ${L+r},${B}H${SPLIT.aBot}Z`},
      {code:o.flags[1],x:SPLIT.bBot,w:R-SPLIT.bBot,d:`M${SPLIT.bTop},${T}H${R-r}A${r},${r} 0 0 1 ${R},${T+r}V${B-r}A${r},${r} 0 0 1 ${R-r},${B}H${SPLIT.bBot}Z`}];
  }else{
    const Rr=SINGLE_RIGHT;
    slots=[{code:o.flags[0],x:L,w:Rr-L,d:`M${L+r},${T}H${Rr-r}A${r},${r} 0 0 1 ${Rr},${T+r}V${B-r}A${r},${r} 0 0 1 ${Rr-r},${B}H${L+r}A${r},${r} 0 0 1 ${L},${B-r}V${T+r}A${r},${r} 0 0 1 ${L+r},${T}Z`}];
  }
  const fr=FRAME.r, R0=FRAME.left, R1=right;
  const frame=`M${R0+fr},0H${R1-fr}A${fr},${fr} 0 0 1 ${R1},${fr}V${H-fr}A${fr},${fr} 0 0 1 ${R1-fr},${H}H${R0+fr}A${fr},${fr} 0 0 1 ${R0},${H-fr}V${fr}A${fr},${fr} 0 0 1 ${R0+fr},0Z`;
  const flags=slots.map((s,i)=>{
    const inner=s.code?(()=>{const im=cover(s.code,s.x,T,s.w,h);return `<image href="${flagHref(s.code)}" x="${im.x.toFixed(1)}" y="${im.y.toFixed(1)}" width="${im.w.toFixed(1)}" height="${im.h.toFixed(1)}" preserveAspectRatio="none"/>`})()
      :`<rect x="${s.x}" y="${T}" width="${s.w}" height="${h}" fill="${o.bar==="light"?"#dfe3e3":"#2a2e30"}"/>`;
    return `<clipPath id="${id}${i}"><path d="${s.d}"/></clipPath><g clip-path="url(#${id}${i})">${inner}</g>`;
  }).join("");
  const x0=FRAME.left+SHEAR*H-14, vbw=right-x0+14;
  return {vbw,svg:`<svg xmlns="http://www.w3.org/2000/svg" viewBox="${x0.toFixed(1)} -8 ${vbw.toFixed(1)} 616" role="img" aria-label="${o.bar==="light"?"Light":"Dark"} bar: ${esc(name)}">
    <g transform="matrix(1,0,${SHEAR},1,0,0)"><path d="${frame}" fill="${c.frame}"/>${flags}
    <text x="${tx.toFixed(1)}" y="${TEXT.base}" font-size="${fontSize().toFixed(1)}" fill="${c.ink}" style="font-family:${FONT_CSS};font-weight:${FONT_WEIGHT}">${esc(name)}</text></g></svg>`};
}
function search(q){
  const t=norm(q);
  const POP=["US","CA","MX","US-CA","CA-BC","CA-ON","GB","AU","BR"];
  if(!t) return POP.map(c=>BY[c]).filter(Boolean);
  const out=[];
  LIB.forEach(o=>{
    const n=norm(o.name);let s=-1;
    if(n===t) s=100; else if(n.startsWith(t)) s=80; else if(n.split(" ").some(w=>w.startsWith(t))) s=60; else if(n.includes(t)) s=40;
    if(o.aliases.some(a=>a.toLowerCase()===t)) s=Math.max(s,70);
    Object.entries(ALIAS).forEach(([k,v])=>{if(v===o.code&&(k===t||(t.length>2&&k.startsWith(t))))s=Math.max(s,k===t?95:55)});
    if(s>=0) out.push([s+(o.group==="Countries"?2:0),o]);
  });
  out.sort((a,b)=>b[0]-a[0]||a[1].name.localeCompare(b[1].name));
  return out.slice(0,24).map(x=>x[1]);
}
/* Flag emoji: 🇳🇺 → NU (regional indicators), 🏴 tag sequences → GB-SCT / US-TX */
function emojiFlag(raw){
  const cps=[...String(raw||"")].map(c=>c.codePointAt(0));
  const ri=cps.filter(c=>c>=0x1F1E6&&c<=0x1F1FF);
  if(ri.length===2){const c=String.fromCharCode(ri[0]-0x1F1E6+65,ri[1]-0x1F1E6+65);return BY[c]?c:null}
  if(cps[0]===0x1F3F4){
    const t=cps.filter(c=>c>=0xE0061&&c<=0xE007A).map(c=>String.fromCharCode(c-0xE0061+97)).join("").toUpperCase();
    if(t.length>=4){const c=t.slice(0,2)+"-"+t.slice(2);return BY[c]?c:null}
  }
  return null;
}
function exactMatch(text){
  const em=emojiFlag(text); if(em) return em;
  const t=norm(text); if(!t) return null;
  if(AMBIG[t]&&AMBIG[t].length) return null;
  if(INDEX.has(t)) return INDEX.get(t);
  const s=t.replace(/\b(state of|province of|the state of|flag of|flag)\b/g," ").replace(/\b(usa|us|united states( of america)?|canada|uk)$/,"").replace(/\s+/g," ").trim();
  return s&&INDEX.has(s)?INDEX.get(s):null;
}

class CsNameBarBuilder extends HTMLElement{
  connectedCallback(){
    if(this._init) return; this._init=true;
    const d=this.dataset;
    this.mode=d.mode==="split"?"split":"single";
    this.base=d.flagBase||"";
    this.flagHref=code=>`${this.base}nb-flag-${code}.svg`;
    this.stage=this.querySelector("[data-stage]");
    this.nameInput=this.querySelector("[data-name]");
    this.prints=this.querySelector("[data-prints]");
    this.count=this.querySelector("[data-count]");
    this.hint=this.querySelector("[data-hint]");
    this.slots=[...this.querySelectorAll("[data-flag-slot]")].map(el=>this.combo(el));
    const swap=this.querySelector("[data-swap]");
    if(swap) swap.addEventListener("click",()=>{
      const a=this.slots[0].get(), b=this.slots[1].get();
      this.slots[0].set(b,true); this.slots[1].set(a,true); this.render();
    });
    this.nameInput.addEventListener("input",()=>this.render());
    this.render();
    if(document.fonts&&document.fonts.load){
      document.fonts.load(`${FONT_WEIGHT} 100px "${FONT_FAMILY}"`).then(()=>{capRatio=null;this.render()}).catch(()=>{});
    }
  }
  combo(host){
    const input=host.querySelector("input[type=text]"), code=host.querySelector("input[type=hidden]");
    const img=host.querySelector("[data-thumb]"), list=host.querySelector("[role=listbox]");
    const lid=list.id;
    let items=[],active=0,value=null;
    const self=this;
    function render(){
      let html="",last="";
      items.forEach((o,i)=>{
        if(o.manual){html+=`<li class="cs-nb__opt cs-nb__opt--manual" role="option" id="${lid}-${i}" data-i="${i}" aria-selected="${i===active}">Not listed? Use “${esc(input.value.trim())}” and we'll design it by hand</li>`;return}
        if(o.group!==last){html+=`<li class="cs-nb__grp" role="presentation">${o.group}</li>`;last=o.group}
        html+=`<li class="cs-nb__opt" role="option" id="${lid}-${i}" data-i="${i}" aria-selected="${i===active}"><img src="${self.flagHref(o.code)}" alt="" loading="lazy" width="30" height="20"><span>${esc(o.name)}</span></li>`;
      });
      if(!items.length) html=`<li class="cs-nb__none">No flags match.</li>`;
      list.innerHTML=html; list.hidden=false; input.setAttribute("aria-expanded","true");
      input.setAttribute("aria-activedescendant",items.length?`${lid}-${active}`:"");
      const a=list.querySelector('[aria-selected="true"]'); if(a) a.scrollIntoView({block:"nearest"});
    }
    function fill(){items=search(input.value);if(input.value.trim().length>1&&!exactMatch(input.value))items.push({manual:true});active=0;render()}
    function close(){list.hidden=true;input.setAttribute("aria-expanded","false")}
    function show(v){
      if(v&&v.code){input.value=BY[v.code].name;code.value=v.code;img.src=self.flagHref(v.code);img.hidden=false;host.classList.add("has-flag")}
      else if(v&&v.custom){input.value=v.custom;code.value="CUSTOM";img.hidden=true;host.classList.remove("has-flag")}
      else{code.value="";img.hidden=true;host.classList.remove("has-flag")}
    }
    function set(v,silent){value=v;show(v);if(!silent)self.render()}
    function pick(i){const o=items[i];if(!o)return;set(o.manual?{custom:input.value.trim()}:{code:o.code});close()}
    function commitTyped(){
      const t=input.value.trim();
      if(!t){set(null);return}
      if(value&&value.code&&BY[value.code].name===t){show(value);return}
      const c=exactMatch(t); set(c?{code:c}:{custom:t});
    }
    input.addEventListener("focus",()=>{if(value&&value.code)input.select();items=search(value&&value.code?"":input.value);active=0;render()});
    input.addEventListener("input",()=>{img.hidden=true;host.classList.remove("has-flag");fill()});
    input.addEventListener("keydown",e=>{
      if(e.key==="ArrowDown"){e.preventDefault();if(list.hidden)fill();else{active=Math.min(active+1,items.length-1);render()}}
      else if(e.key==="ArrowUp"){e.preventDefault();active=Math.max(active-1,0);render()}
      else if(e.key==="Enter"){if(!list.hidden&&items.length){e.preventDefault();pick(active)}}
      else if(e.key==="Escape"){close();show(value)}
    });
    input.addEventListener("blur",()=>setTimeout(()=>{if(!host.contains(document.activeElement)){close();commitTyped()}},150));
    list.addEventListener("mousedown",e=>{const li=e.target.closest("[data-i]");if(li){e.preventDefault();pick(+li.dataset.i)}});
    const pre=exactMatch(input.value); if(pre) set({code:pre},true);
    return {set,get:()=>value};
  }
  render(){
    const raw=this.nameInput.value, f=formatName(raw);
    const max=+this.nameInput.maxLength||20;
    this.count.textContent=`${raw.length}/${max}`;
    this.prints.value=f.text;
    if(!raw.trim()){this.hint.textContent=this.dataset.hintEmpty||"";this.hint.classList.remove("is-note")}
    else if(f.changed){this.hint.textContent=`We'll print it as ${f.text} so every bar matches.`;this.hint.classList.add("is-note")}
    else{this.hint.textContent=this.dataset.hintOk||"";this.hint.classList.remove("is-note")}
    const flags=this.slots.map(s=>{const v=s.get();return v&&v.code?v.code:null});
    const REF=5200;
    this.stage.innerHTML=["light","dark"].map(bar=>{
      const r=decalSVG({name:raw,mode:this.mode,flags,bar},this.flagHref);
      return `<div class="cs-nb__bar" style="width:${Math.min(100,r.vbw/REF*100).toFixed(1)}%">${r.svg}</div>`;
    }).join("");
  }
}
if(!customElements.get("cs-namebar-builder")) customElements.define("cs-namebar-builder",CsNameBarBuilder);

})();
  } catch(e) { console.error(e); }
})();

})();
